import { jsx } from "react/jsx-runtime";
import { useWidthComparison } from "@perxis-auto/shared";
import classnames from "../../utils/classnames.js";
import Status from "../Status/Status.js";
import Tooltip from "../Tooltip/Tooltip.js";
import './CarTile.css';/* empty css             */
const CarTileStatus = ({ iconColor, label, className }) => {
  const { isWidthsEqual, containerRef, componentRef } = useWidthComparison();
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-car-tile-status", className), ref: containerRef, children: /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-car-tile-status__content"), ref: componentRef, children: isWidthsEqual ? /* @__PURE__ */ jsx(Tooltip, { title: label, placement: "top", children: /* @__PURE__ */ jsx(Status, { iconColor, children: label }) }) : /* @__PURE__ */ jsx(Status, { iconColor, children: label }) }) });
};
export {
  CarTileStatus as default
};
//# sourceMappingURL=CarTileStatus.js.map
